import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_false, not_implemented_type } from '@shared/asserts/utils_asserts';
import { ENUM__field_kind } from '../../_enums/ENUM__field_kind';
import { ERROR_GRAPH__field } from '../../_errors/ERROR_GRAPH__field';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD__base } from './FIELD__base';

declare module './FIELD__base' {
  interface FIELD__base {
    error_add(error_type: ENUM__error_type): ERROR_GRAPH__field;

    validate(graph: DTO_GRAPH__instance): void;

    validate_children(graph: DTO_GRAPH__instance): void;

    _validate__case_base(graph: DTO_GRAPH__instance): void;

    /*
     * INPUT
     */

    _validate__case_input(graph: DTO_GRAPH__instance): void;

    /*
     * OUTPUT
     */
    _validate__case_output(graph: DTO_GRAPH__instance): void;
  }
}

export function INIT_EXTENSION_FIELD_BASE__validation() {}

/*
 * IMPLEMENTATION
 */

FIELD__base.prototype.error_add = function (error_type: ENUM__error_type) {
  let out = ERROR_GRAPH__field.create(error_type, this);

  this.meta.errors.push(out);

  return out;
};

FIELD__base.prototype.validate = function (graph: DTO_GRAPH__instance) {
  if (this.meta.data__is_validated) return;

  this.meta.data__is_validated = true;

  if (this.meta.data__is_linked) return;

  this._validate__case_base(graph);

  switch (this.meta.field_kind) {
    case ENUM__field_kind.INPUT:
      this._validate__case_input(graph);
      break;
    case ENUM__field_kind.OUTPUT:
      this._validate__case_output(graph);
      break;
    default:
      not_implemented_type(this.meta.field_kind);
  }
};

FIELD__base.prototype.validate_children = function (graph: DTO_GRAPH__instance) {
  for (let field of Object.values(this)) {
    if (!(field instanceof FIELD__base)) continue;

    field.validate(graph);

    this.meta.errors = [...this.meta.errors, ...field.meta.errors];
  }
};

FIELD__base.prototype._validate__case_base = function (graph: DTO_GRAPH__instance) {};

/*
 * INPUT
 */

FIELD__base.prototype._validate__case_input = function (graph: DTO_GRAPH__instance) {
  this.validate_children(graph);

  assert_false(this.is_stub());
};

/*
 * OUTPUT
 */
FIELD__base.prototype._validate__case_output = function (graph: DTO_GRAPH__instance) {
  this.validate_children(graph);
};
